/* @flow */
import React from 'react';
import RolePicker from 'components/RolePicker.jsx';
import UserActions from 'user/UserActions';
import CenteredContainer from 'components/CenteredContainer.jsx';

class JoinInfoPageRolePicker extends React.Component {
  props: {
    onDone: Function,
    onError: Function,
  }

  saveRole = (role: string) => {
    UserActions.update({ role }).then(this.props.onDone, this.props.onError);
  }

  render() {
    return (
      <CenteredContainer size="large" className="JoinInfoPageRolePicker">
        <RolePicker onSelect={this.saveRole} />
      </CenteredContainer>
    );
  }
}

export default JoinInfoPageRolePicker;



// WEBPACK FOOTER //
// ./src/join/components/JoinInfoPageRolePicker.jsx